import React, { useState } from 'react';

import { Combobox } from '@vwfs-bronson/bronson-react';
import { PostboxDocument } from 'cpes-common';
import { useTranslation } from 'react-i18next';

import { AllTimeframes, getListOfAvailableTimeframes, Timeframe } from '../../helper/Timeframe';
import { ComboboxState } from '../../../../types/bronson-react';
import { ComboboxOption } from '@cp-shared-19/frontend-ui';

export type TimeframeFilterProps = {
    postboxDocuments?: PostboxDocument[];
    onChange: (value: Timeframe | AllTimeframes) => void;
    initialValue?: Timeframe | AllTimeframes;
};

export const TimeframeFilter: React.FC<TimeframeFilterProps> = ({ postboxDocuments, onChange, initialValue }) => {
    const { t } = useTranslation('postbox');

    const availableOptionsWithTranslations = getListOfAvailableTimeframes(postboxDocuments || []).map(timeframe => ({
        ...timeframe,
        translation: t(`filters.timeframe.select-items.${timeframe.translation}`),
    }));

    const availableOptionElements = availableOptionsWithTranslations.map(timeframe => ({
        key: timeframe.key,
        value: {
            textValue: timeframe.translation as string,
            content: <div>{timeframe.translation}</div>,
        },
    }));

    const initialSelectedOption = availableOptionElements.find(option => option.key === initialValue);

    const [selectedItem, setSelectedItem] = useState<{ value: ComboboxOption[] }>({
        value: initialSelectedOption ? [(initialSelectedOption as unknown) as ComboboxOption] : [],
    });

    if (!postboxDocuments) {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectValueChange = (selected: any): void => {
        setSelectedItem({ value: [selected[0]] });
        onChange(selected[0].key as Timeframe | AllTimeframes);
    };

    const defaultOption =
        availableOptionsWithTranslations.find(timeframe => timeframe.key === initialValue) ||
        availableOptionsWithTranslations[0];

    const defaultItem: ComboboxState = {
        value: [
            {
                key: defaultOption.key,
                value: defaultOption.translation,
            },
        ],
    };

    return (
        <>
            <label>{t('filters.timeframe.label')}</label>
            <Combobox
                className="c-form-field--no-floating"
                testId={'TimeframeFilter'}
                onChange={selectValueChange}
                value={selectedItem.value}
                options={availableOptionElements}
                defaultState={defaultItem}
            />
        </>
    );
};
